import styles from "./PageButton.module.css";
import { useNavigate } from "react-router-dom";

function PageButton({ img, title, description, nav }) {
  const navigate = useNavigate();
  return (
    <button className={styles.pageButton} onClick={() => navigate(nav)}>
      <img src={img} alt={`${title} button`} />
      <div className={styles.pageButtonDetails}>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    </button>
  );
}

export default PageButton;
